import {useEffect} from 'react'
import {StyleSheet, View} from 'react-native'

import {useChatBubbleDispatch} from '#/state/chat-bubble'
import {useGetConvoForMembers} from '#/state/queries/messages/get-convo-for-members'
import {atoms as a, useTheme} from '#/alf'
import {Loader} from '#/components/Loader'
import {Text} from '#/components/Typography'

/**
 * Handles creating/finding a conversation when none exists yet.
 * Once the convoId is resolved, dispatches SET_CONVO_ID.
 */
export function ConvoInitializer({
  windowId,
  recipientDid,
}: {
  windowId: string
  recipientDid: string
}) {
  const t = useTheme()
  const dispatch = useChatBubbleDispatch()

  const {mutate, isPending, isError} = useGetConvoForMembers({
    onSuccess: data => {
      dispatch({
        type: 'SET_CONVO_ID',
        windowId,
        convoId: data.convo.id,
      })
    },
    onError: () => {
      // Error state will be shown via isError
    },
  })

  useEffect(() => {
    mutate([recipientDid])
  }, [mutate, recipientDid])

  return (
    <View style={[styles.container, t.atoms.bg]}>
      {isPending && (
        <View style={styles.center}>
          <Loader size="lg" />
          <Text style={[a.text_sm, {color: t.palette.contrast_500}]}>
            Starting conversation...
          </Text>
        </View>
      )}
      {isError && (
        <View style={styles.center}>
          <Text style={[a.text_sm, {color: '#ef4444'}]}>
            Failed to start conversation
          </Text>
        </View>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  center: {
    alignItems: 'center',
    gap: 8,
  },
})
